var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7266 10.2539H18.3594C17.4951 10.2539 16.7969 10.9521 16.7969 11.8164V23.3398H5.27344C4.40918 23.3398 3.71094 24.0381 3.71094 24.9023V38.1836C3.71094 39.0479 4.40918 39.7461 5.27344 39.7461H31.6406C32.5049 39.7461 33.2031 39.0479 33.2031 38.1836V26.6602H44.7266C45.5908 26.6602 46.2891 25.9619 46.2891 25.0977V11.8164C46.2891 10.9521 45.5908 10.2539 44.7266 10.2539ZM20.1172 13.5742H29.8828V23.3398H20.1172V13.5742ZM16.7969 36.4258H7.03125V26.6602H16.7969V36.4258ZM29.8828 36.4258H20.1172V26.6602H29.8828V36.4258ZM42.9688 23.3398H33.2031V13.5742H42.9688V23.3398Z",
    fill: "#0094FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildOutlined);
export default __webpack_public_path__ + "static/media/BuildOutlined.6c5b1e98afee484c2249cc2289280279.svg";
export { ForwardRef as ReactComponent };